import Vue from 'vue'

export const Events = new Vue()
export default Events
